'use client'

import { urlForImage } from "@/sanity/lib/image"
import Autoplay from 'embla-carousel-autoplay'
import useEmblaCarousel from 'embla-carousel-react'
import Image from "next/image"
import {
	useEffect,
	useState
} from 'react'

interface ImageCarouselProps {
	images: any
}

export default function ImageCarousel({images}:ImageCarouselProps) {

	const [emblaRef, emblaApi] = useEmblaCarousel({
		align: 'start',
		loop: true
	}, [Autoplay({delay: 4000})])
	const [selectedIndex, setSelectedIndex] = useState<number>(0)

	useEffect(() => {
		if (!emblaApi) return

		const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap())
		emblaApi.on('select', onSelect)

		return () => {
			emblaApi.off('select', onSelect)
		}
	}, [emblaApi])

	const slideTo = (index) => {
		if (!emblaApi) return
		emblaApi?.scrollTo(index)
	}

	return (
		<div className={`relative w-full`}>
			<div ref={emblaRef} className="embla w-full overflow-clip">
				<div className="embla__container w-full flex">
					{images?.map((image, index) => (
						<div key={`slide-${index}`} className="embla__slide w-full aspect-video flex-none">
							<Image
								className={`w-full h-full object-cover`}
								src={urlForImage(image).url()}
								width={image?.asset?.metadata?.dimensions?.width}
								height={image?.asset?.metadata?.dimensions?.height}
								sizes="100vw"
								alt={image?.alt || ''}
								placeholder="blur"
								blurDataURL={image?.asset?.metadata?.lqip}
								unoptimized={image?.asset?.url?.includes(".gif") ? true : false} // mark Gif images as unoptimized (Next.js does not support Gif optimisation yet)
							/>
						</div>
					))}
				</div>

				<div className="absolute bottom-4 md:bottom-8 left-4 md:left-8 flex gap-4">
					{images?.map((image, index) => (
						<button
							key={`thumb-${index}`}
							className={`w-12 md:w-16 aspect-video flex-none border-solid border ${index === selectedIndex ? 'border-white opacity-100' : 'border-transparent opacity-80'} rounded-weak overflow-clip`}
							onClick={() => slideTo(index)}>
							<Image
								className={`w-full h-full object-cover`}
								src={urlForImage(image).url()}
								width={image?.asset?.metadata?.dimensions?.width}
								height={image?.asset?.metadata?.dimensions?.height}
								sizes="10vw"
								alt={image?.alt || ''}
								placeholder="blur"
								blurDataURL={image?.asset?.metadata?.lqip}
								unoptimized={image?.asset?.url?.includes(".gif") ? true : false} // mark Gif images as unoptimized (Next.js does not support Gif optimisation yet)
							/>
						</button>
					))}
				</div>
			</div>
		</div>
	)
}
